import React from 'react';
import '../.././components/css/popupstyle.css';
import $ from 'jquery';
import { userService } from '../../_services';
import { debuglog } from 'util';

class BrokerSignature extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            error: '',
            loader: false,
            nameError: '',
            phoneError: '',
            companyError: '',
            addressLine1Error: '',
            addressLine2Error: ''
        };
        this.pName = React.createRef();
        this.pPhone = React.createRef();
        this.cName = React.createRef();
        this.address1 = React.createRef();
        this.address2 = React.createRef();
    }
    componentDidMount() {
    }
    handleChange = (e) => {
        const { name, value } = e.target;
        this.setState({ [name]: value });
    }
    handleSaveSubmit = () => {
        this.setState({ loader: true });
        let name = this.pName.current.value;
        let phone = this.pPhone.current.value;
        let companyName = this.cName.current.value;
        let address1 = this.address1.current.value;
        let address2 = this.address2.current.value;
        let count = 0;

        if (name.length > 0) {
            // validate name
            if (userService.Check_Null_Empty(name)) {
                this.setState({ nameError: "Partner name can't be blank", loader: false });
                count = 1;
            } else if (userService.ValidateSpace(name)) {
                this.setState({ nameError: 'Space not acceptable', loader: false });
                count = 1;
            }
            // validate phone
            if (userService.Check_Null_Empty(phone)) {
                this.setState({ phoneError: "Partner phone can't be blank", loader: false });
                count = 1;
            } else if (userService.ValidateSpace(phone)) {
                this.setState({ phoneError: 'Space not acceptable', loader: false });
                count = 1;
            } else if (!userService.validateNumber(phone)) {
                this.setState({ phoneError: "Invalid phone number", loader: false });
                count = 1;
            }
            // validate company name
            if (userService.Check_Null_Empty(companyName)) {
                this.setState({ companyError: "Company name can't be blank", loader: false });
                count = 1;
            } else if (userService.ValidateSpace(companyName)) {
                this.setState({ companyError: 'Space not acceptable', loader: false });
                count = 1;
            }
            // validate address1
            if (userService.Check_Null_Empty(address1)) {
                this.setState({ addressLine1Error: "Address Line1 can't be blank", loader: false });
                count = 1;
            } else if (userService.ValidateSpace(address1)) {
                this.setState({ addressLine1Error: 'Space not acceptable', loader: false });
                count = 1;
            }
            // validate address2
            if (userService.Check_Null_Empty(address2)) {
                this.setState({ addressLine2Error: "Address Line2 can't be blank", loader: false });
                count = 1;
            } else if (userService.ValidateSpace(address2)) {
                this.setState({ addressLine2Error: 'Space not acceptable', loader: false });
                count = 1;
            }
            if (count == 0) {
                this.ProcessBrokerSetting(this.props.GroupNumber, name, phone, companyName, address1, address2);
            }
        } else {
            this.setState({ nameError: "Partner name can't be blank", loader: false });
            count = 1;
        }
    }
    ProcessBrokerSetting = (groupNumber, partnerName, partnerPhone, companyName, addressLine1, addressLine2) => {
        try {
            userService.BrokerSignatureSetting(groupNumber, partnerName, partnerPhone, companyName, addressLine1, addressLine2).then(
                apidata => {
                    try {
                        if (apidata.length > 0) {
                            this.setState({ Loader: false, error: apidata[0].message });
                            if (apidata[0].code == '1') {
                                $('.save-btn').attr('disabled', true);
                                setTimeout(() => {
                                    this.closeBrokerPopup();
                                }, 3000);
                            }
                        } else {
                            this.setState({ Loader: false, error: 'Opps!, Something went wrong. Try Again.' });
                        }
                    }
                    catch (error) {
                        this.setState({ Loader: false, error: 'Opps!, Something went wrong. Try Again.' });
                    }
                }
            );
        }
        catch (error) {
            this.setState({ btnLoader: false, error: 'Opps!, Something went wrong. Try Again.' });
        }
    }
    closeBrokerPopup = () => {
        this.props.closeBrokerPopup(this.props.GroupNumber);
        this.props.openManageGroup(this.props.GroupNumber, this.props.MaxComm, this.props.cPagin, this.props.cSearch);
    }
    handleBack = () => {
        this.props.closeBrokerPopup(this.props.GroupNumber);
        this.props.openEditGroup('', '', 'yes', this.props.userLists);
    }
    HandleSearchKeyUp = e => {
        if ($(e.target).attr('name') == 'partnerName') {
            this.setState({ nameError: '' });
        }
        if ($(e.target).attr('name') == 'partnerPhone') {
            this.setState({ phoneError: '' });
        }
        if ($(e.target).attr('name') == 'companyName') {
            this.setState({ companyError: '' });
        }
        if ($(e.target).attr('name') == 'address1') {
            this.setState({ addressLine1Error: '' });
        }
        if ($(e.target).attr('name') == 'address2') {
            this.setState({ addressLine2Error: '' });
        }
    }
    render() {
        const { loader, error, nameError, phoneError, companyError, addressLine1Error, addressLine2Error } = this.state;
        return (
            <div className='popup override-content broker-signature'>
                <div className='popup_inner manage-distributor-design wh-edit-group'>
                    <h1>{this.props.text}<button onClick={this.handleBack}>X</button></h1>
                    <form name="form" className="referralPopup">
                        <div className="field-data">
                            <formgroup>
                                <div className="col-lg-4">
                                    <label>Partner Name: </label>
                                    <input ref={this.pName} type="text" name='partnerName' className="form-control" onChange={this.handleChange} defaultValue="" onKeyUp={this.HandleSearchKeyUp} />
                                    {
                                        nameError &&
                                        <div className={'alert alert-danger m-group'}>{nameError}</div>
                                    }
                                </div>
                                <div className="col-lg-4 gap">
                                    <label>Partner Phone: </label>
                                    <input ref={this.pPhone} name='partnerPhone' type="text" className="form-control" onChange={this.handleChange} defaultValue="" onKeyUp={this.HandleSearchKeyUp} />
                                    {
                                        phoneError &&
                                        <div className={'alert alert-danger m-group'}>{phoneError}</div>
                                    }
                                </div>
                                <div className="col-lg-4">
                                    <label>Company Name: </label>
                                    <input ref={this.cName} name='companyName' type="text" className="form-control" onChange={this.handleChange} defaultValue="" onKeyUp={this.HandleSearchKeyUp} />
                                    {
                                        companyError &&
                                        <div className={'alert alert-danger m-group'}>{companyError}</div>
                                    }
                                </div>
                            </formgroup>
                            <formgroup>
                                <div className="col-lg-4">
                                    <label>Address Line1: </label>
                                    <input ref={this.address1} name='address1' type="text" className="form-control" onChange={this.handleChange} defaultValue="" onKeyUp={this.HandleSearchKeyUp} />
                                    {
                                        addressLine1Error &&
                                        <div className={'alert alert-danger m-group'}>{addressLine1Error}</div>
                                    }
                                </div>
                                <div className="col-lg-4 gap">
                                    <label>Address Line2: </label>
                                    <input ref={this.address2} name='address2' type="text" className="form-control" onChange={this.handleChange} defaultValue="" onKeyUp={this.HandleSearchKeyUp} />
                                    {
                                        addressLine2Error &&
                                        <div className={'alert alert-danger m-group'}>{addressLine2Error}</div>
                                    }
                                </div>
                            </formgroup>
                        </div>

                        <div className="button-section manage-btn-section">
                            <input type="button" className={loader ? 'btn animated-btn save-btn' : 'btn save-btn'} onClick={this.handleSaveSubmit} value="Save & Submit" />
                            <input type="button" onClick={this.handleBack} className="btn cancel" value="Cancel" />
                            {loader &&
                                <div className="theme-loader"></div>
                            }
                            {error &&
                                <div className={'alert alert-danger m-group'}>{error}</div>
                            }
                        </div>

                    </form>
                </div>
            </div >

        );
    }
}


export default BrokerSignature;